import { EtapeBonTravailEntite } from 'src/app/entites/mecanique/etape-bon-travail';
import { ReponseAjouterEtapesBonTravail } from 'src/app/services/reponses/reponse-ajouter-etapes-bon-travail';

export interface RequeteAjouterEtapesBonTravail {
    bonTravailId: number;
    etapesPreventif?: EtapeBonTravailEntite[];
    etapesCorrectif?: EtapeBonTravailEntite[];
    etapesVerification?: EtapeBonTravailEntite[];
    etapesManuel?: EtapeBonTravailEntite[];
}

export interface SelectionEtapesPourAjout {
    etapesPreventif?: EtapeBonTravailEntite[];
    etapesCorrectif?: EtapeBonTravailEntite[];
    etapesVerification?: EtapeBonTravailEntite[];
    etapesManuel?: EtapeBonTravailEntite[];
}

/** Builds the POST /etapes payload so manual steps are always sent as `etapesManuel`. */
export function construireRequeteAjouterEtapes(
    bonTravailId: number,
    selection: SelectionEtapesPourAjout = {}
): RequeteAjouterEtapesBonTravail {
    return {
        bonTravailId,
        etapesPreventif: selection.etapesPreventif ?? [],
        etapesCorrectif: selection.etapesCorrectif ?? [],
        etapesVerification: selection.etapesVerification ?? [],
        etapesManuel: selection.etapesManuel ?? [],
    };
}

/** Manual steps from the API, including the legacy singular field. */
export function etapesManuellesCreees(
    reponse: ReponseAjouterEtapesBonTravail | undefined
): EtapeBonTravailEntite[] {
    if (reponse?.etapesManuel?.length) {
        return reponse.etapesManuel;
    }
    return reponse?.etapeManuel ? [reponse.etapeManuel] : [];
}

/** Every step persisted by POST /etapes. */
export function etapesCreeesDepuisReponse(
    reponse: ReponseAjouterEtapesBonTravail | undefined
): EtapeBonTravailEntite[] {
    if (!reponse) {
        return [];
    }
    return [
        ...(reponse.etapesPreventif ?? []),
        ...(reponse.etapesCorrectif ?? []),
        ...(reponse.etapesVerification ?? []),
        ...etapesManuellesCreees(reponse),
    ];
}

/** True when the dialog sent manual steps but the API persisted none. */
export function etapesManuellesNonPersistees(
    nbDemandees: number,
    creees: EtapeBonTravailEntite[] | undefined
): boolean {
    return nbDemandees > 0 && (creees?.length ?? 0) === 0;
}

/** Appends newly persisted steps that are not already on the BT. */
export function fusionnerEtapesAjoutees(
    existantes: EtapeBonTravailEntite[] | undefined,
    creees: EtapeBonTravailEntite[] | undefined
): EtapeBonTravailEntite[] {
    const actuelles = existantes ?? [];
    const nouvelles = (creees ?? []).filter(etape =>
        !!etape?.etapeBonTravailId
        && !actuelles.some(actuelle => actuelle.etapeBonTravailId === etape.etapeBonTravailId)
    );
    return nouvelles.length ? [...actuelles, ...nouvelles] : actuelles;
}
